/**
 * @file store.ts
 * @description Redux store configuration combining feature slices and RTK Query APIs.
 */
import { configureStore } from '@reduxjs/toolkit';
import authReducer from '../features/auth/model/authSlice.js';
import strategyBuilderReducer from '../features/strategy/model/strategyBuilderSlice.js';
import { authApi } from '../features/auth/api/authApi.js';
import { marketDataApi } from '../features/chart/api/marketDataApi.js';
import { strategyApi } from '../features/strategy/api/strategyApi.js';
import { backtestApi } from '../features/backtest/api/backtestApi.js';
import { exportApi } from '../features/export/api/exportApi.js';
import { subscriptionApi } from '../features/subscription/api/subscriptionApi.js';
import { paymentApi } from '../features/subscription/api/paymentApi.js';
import { adminApi } from '../features/admin/api/adminApi.js';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    strategyBuilder: strategyBuilderReducer,
    [authApi.reducerPath]: authApi.reducer,
    [marketDataApi.reducerPath]: marketDataApi.reducer,
    [strategyApi.reducerPath]: strategyApi.reducer,
    [backtestApi.reducerPath]: backtestApi.reducer,
    [exportApi.reducerPath]: exportApi.reducer,
    [subscriptionApi.reducerPath]: subscriptionApi.reducer,
    [paymentApi.reducerPath]: paymentApi.reducer,
    [adminApi.reducerPath]: adminApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(
      authApi.middleware,
      marketDataApi.middleware,
      strategyApi.middleware,
      backtestApi.middleware,
      exportApi.middleware,
      subscriptionApi.middleware,
      paymentApi.middleware,
      adminApi.middleware,
    ),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
